__turbopack_context__.v({
  "fadeIn": "DropdownWrapper-module-scss-module__GuWtMa__fadeIn",
});
